import controller from './button-qr-code-scanner.controller';
import template from './button-qr-code-scanner.html';

export default {
	template,
	bindings: {
		ngModel:  '=',
		onChange: '&?',
	},
	controller,
	require:  {
		ngModelCtrl: 'ngModel',
	},
};
